import { combineReducers } from 'redux';

import {
  invitationsListState,
  TeamInvitationsListState,
} from './team-invitations/team-invitations.reducer';
import { projectInvitationsListState } from './team-invitations/project-team-invitations.reducer';
import {
  membersListState,
  TeamMembersListState,
} from './team-members-list/team-members-list.reducer';
import { projectMembersListState } from './team-members-list/project-team-members-list.reducer';
import { TeamUiState, teamUiState } from './team.reducer-ui';

export interface TeamState {
  invitationsListState: TeamInvitationsListState;
  membersListState: TeamMembersListState;
  projectMembersListState: TeamMembersListState;
  projectInvitationsListState: TeamInvitationsListState;
  teamUiState: TeamUiState;
}

export const team = combineReducers<TeamState>({
  invitationsListState,
  membersListState,
  projectMembersListState,
  projectInvitationsListState,
  teamUiState,
});
